import { ExtendableError } from "@seneca/client-library";

export default class ExamQuestionNotFoundError extends ExtendableError {
  constructor() {
    super("ExamQuestionNotFoundError");
  }
}
